module.exports = __webpack_public_path__ + "img/CAnnect-logo-solo.40275430.svg";